export var MAX_QUERY_SIZE = 64;